"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ltCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var ltCountry = exports.ltCountry = function ltCountry(t) {
  return {
    id: 'LT',
    name: t('Lithuania'),
    flag: '🇱🇹',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 0110',
    phonePrefix: '370',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Vilnius',
    currency: 'EUR'
  };
};